import React, { FunctionComponent, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { useInboxStore } from '../../../stores/inbox/useInboxStore'
import { defaultViewToActiveInboxTab } from '../../../stores/inbox/inboxSettingsStore'
import { useInboxSettingsStore } from '../../../stores/inbox/useInboxSettingsStore'
import InboxPage from '../components/inbox/InboxPage'

interface IInboxSectionProps { }

/** Sync inbox tab with settings when entering inbox (e.g. default changed in Settings). */
export const ApplyDefaultInboxView: FunctionComponent = () => {
    const { store: { defaultView } } = useInboxSettingsStore()
    const { store: { activeInboxLabel }, dispatch } = useInboxStore()
    const appliedRef = useRef(false)

    useEffect(() => {
        if (appliedRef.current) return
        appliedRef.current = true
        const label = defaultViewToActiveInboxTab(defaultView)
        if (activeInboxLabel !== label) {
            dispatch({ type: 'set-active-inbox-label', payload: label })
        }
    }, [activeInboxLabel, defaultView, dispatch])

    return null
}

const InboxSection: FunctionComponent<IInboxSectionProps> = () => {
    return (
        <>
            <ApplyDefaultInboxView />
            <Container>
                <InboxPage />
            </Container>
        </>
    )
}

const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

export default InboxSection
